import { autoFormat, abbreviate } from 'app-lib/numberUtils'
import { chainConfigs } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import { Button, Input, Icon } from 'ui-framework'
import WrapNativeFormVM from './WrapNativeFormVM'

export function WrapNativeForm({ form }: { form: WrapNativeFormVM }) {
  const { rootStore, fromTo } = form
  const { chainId } = rootStore.web3Connection
  if (!chainId) {
    return null
  }

  const { native } = chainConfigs[chainId]

  return (
    <div className="txt-explanation">
      {form.directionAllowed && (
        <>
          <ul>
            <li className="margin-bottom-1">
              You have{' '}
              <b title={form.fromTo.to.balance.toFixed()} className="txt-positive">
                {autoFormat(form.fromTo.to.balance)}
              </b>{' '}
              {form.fromTo.to.asset}.{' '}
            </li>

            <li>
              You can swap{' '}
              <b title={form.fromTo.from.balance.toFixed()} className="txt-positive">
                {autoFormat(form.fromTo.from.balance)}
              </b>{' '}
              {form.fromTo.from.asset} to {form.fromTo.to.asset} from your wallet.
            </li>
          </ul>
        </>
      )}

      {!form.directionAllowed && (
        <div className="panel--alternative padded-1 margin-bottom-1">
          <div className="grid-3-col items-center">
            <div className="txt-left">
              <b>{fromTo.from.asset}</b>
              <div>
                <Icon name="wallet-balance" color="var(--color-txt-muted)" size={20} top={-2} />{' '}
                <Button variant="link" onClick={form.setToMax}>
                  {abbreviate(fromTo.from.balance)}
                </Button>
              </div>
            </div>

            <Button variant="invisible" className="margin-h-2" onClick={form.toggleReceive}>
              <Icon
                name="arrow-right"
                size={32}
                bgCircle
                color="var(--color-blue-aim)"
                bgPadding={6}
                borderColor="var(--color-blue-aim)"
              />
            </Button>

            <div className="txt-right">
              <b>{fromTo.to.asset}</b>
              <div>
                <Icon name="wallet-balance" color="var(--color-txt-muted)" size={20} top={-2} />{' '}
                {abbreviate(fromTo.to.balance)}
              </div>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={form.submit}>
        <div className="margin-bottom-1">
          <label className="txt-subtitle" htmlFor="input-from-amount">
            {fromTo.from.asset} swap amount
          </label>
          <div className="wrap-native__grid">
            <div className="input-with-sticked-btn">
              <Input
                id="input-from-amount"
                onChangeEmit="name-value"
                name="inputAmount"
                value={form.inputAmount}
                onChange={form.set}
              />
              <Button isLoading={form.nativeBalancePending} variant="blue" onClick={form.setToMax}>
                Max
              </Button>
            </div>
            <div className="txt-right flex-row-end">
              <Button
                className="no-wrap"
                variant="green"
                type="submit"
                isLoading={form.swapPending}>
                Get {fromTo.to.asset}
              </Button>
            </div>
          </div>
        </div>
        {fromTo.from.asset === native.asset && (
          <i>Note: keep some {native.asset} to pay for your transactions.</i>
        )}
      </form>
    </div>
  )
}

export default observer(WrapNativeForm)
